import { useEffect, useState } from "react";
import { iconUrl } from "@engine/sprites/ItemSpriteResolver.js";

/**
 * A05b — `useItemIcon(itemId)`
 *
 * Probes the {@link iconUrl} resolver and returns the resulting URL once
 * known. The hook starts in a `loading` state, then resolves to either
 * the resolved adventure/public URL or `null` (in which case the consumer
 * should render the procedural letter-tile fallback). Cached probes
 * resolve synchronously on first render.
 */
export interface ItemIconState {
  readonly url: string | null;
  readonly loaded: boolean;
}

export function useItemIcon(itemId: string): ItemIconState {
  const [state, setState] = useState<ItemIconState>({ url: null, loaded: false });

  useEffect(() => {
    let cancelled = false;
    setState({ url: null, loaded: false });
    void iconUrl(itemId).then((url) => {
      if (cancelled) return;
      setState({ url, loaded: true });
    });
    return () => {
      cancelled = true;
    };
  }, [itemId]);

  return state;
}
